import { render, staticRenderFns } from "./CreateCouponModal.vue?vue&type=template&id=06c9a118&scoped=true"
import script from "./CreateCouponModal.vue?vue&type=script&lang=ts"
export * from "./CreateCouponModal.vue?vue&type=script&lang=ts"
import style0 from "./CreateCouponModal.vue?vue&type=style&index=0&id=06c9a118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c9a118",
  null
  
)

export default component.exports